import axios from "axios";
import { storageApi } from "../storage/storageApi";
import { BASE_API_URL } from "../config";
import { useEffect, useState } from "react";
import { useAlert } from "react-alert";

const axiosRequest = ({ params, endpoint }) => {
  console.log("API CALL:", { params });

  if (params.formData && Object.keys(params.formData).length > 0) {
    const formData = new FormData();
    for (const i of Object.keys(params?.data ?? {})) {
      formData.set(i, params.data[i]);
    }
    for (const i of Object.keys(params.formData)) {
      formData.set(i, params.formData[i]);
    }
    params.data = formData;
  }

  return new Promise((resolve) => {
    axios
      .request({ ...params })
      .then((result) =>
        resolve({ result: { response: result }, endpoint, isOk: true }),
      )
      .catch((result) => resolve({ result, endpoint, isOk: false }));
  });
};

const axiosResultHandler = (results) => {
  return results.map(({ result, isOk, endpoint }) => {
    const errorObject = isOk
      ? {}
      : {
          code: result.code,
          name: result.name,
          message: result.message,
          display: "",
          realCodeList: [],
          displayList: [],
        };

    const resultObject = {
      isOk,
      status: result.response?.status,
      error: errorObject,
      response: result,
      data: result.response?.data,
      endpoint,
    };

    const realErrorCodes = !isOk ? endpoint.handleError(resultObject) : [];
    const error = realErrorCodes
      .map((e) => endpoint.error?.[e] ?? e)
      .filter((c) => !!c);

    if (error.length === 0) {
      error.push("خطایی رخ داده است");
    }

    if (!isOk) {
      errorObject.display = error.join(", ");
      errorObject.displayList = error;
      errorObject.realCodeList = realErrorCodes;
    }

    const normalizedData = isOk
      ? endpoint.handleResponse(resultObject)
      : resultObject.data;

    return {
      ...resultObject,
      data: normalizedData,
    };
  });
};

export const useApiCall = ({ endpoints, payload = {}, lazy = false }) => {
  endpoints = Array.isArray(endpoints) ? endpoints : [endpoints];

  const alert = useAlert();
  const logout = storageApi.useLogout();

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState([]);

  const call = async (fetchPayload = {}) => {
    setLoading(true);
    const apiResults = await Promise.all(
      endpoints.map((endpoint) => {
        const requestPayload = {
          ...payload,
          ...fetchPayload,
        };
        const {
          params,
          body,
          urlParams = {},
          formData = {},
        } = endpoint?.input?.(requestPayload) ?? requestPayload;

        const authorizeHeader = endpoint.isAnonymous
          ? {}
          : { authorization: `Bearer ${storageApi.getUserToken()}` };

        return axiosRequest({
          params: {
            method: endpoint.config.method,
            headers: {
              ...authorizeHeader,
              ...endpoint.headers,
            },
            params,
            results: body,
            data: body,
            formData,
            baseURL: BASE_API_URL,
            url:
              typeof endpoint.url === "function"
                ? endpoint.url(urlParams)
                : endpoint.url,
          },
          endpoint,
        });
      }),
    );
    const handledResult = axiosResultHandler(apiResults);
    setResult(handledResult);
    setLoading(false);

    const errorList = handledResult.filter(
      (c) => !c.isOk && !c.endpoint.ignoreAlert,
    );

    errorList
      .filter((c) => c.status !== 401)
      .map(({ error }) => {
        alert.error(error.display);
      });

    if (errorList.find((e) => e.status === 401)) {
      //REFRESH TOKEN
      alert.error("سشن شما منقضی شده لطفا مجدد وارد شود");
      logout();
      location.reload();
    }

    return handledResult;
  };

  useEffect(() => {
    if (!lazy) {
      call();
    }
  }, []);

  const info = {
    fetch(fetchPayload) {
      return call(fetchPayload);
    },
    loading,
  };

  return [result, info];
};
